var t = {};
export {
  t as __exports
};
//# sourceMappingURL=index.es489.js.map
